<template>
  <v-text-field
    @input="$emit('input', sanitizeInput($event))"
    :id="id"
    :value="value"
    :label="label"
    :disabled="isReadOnly || disabled"
    :rules="allRules"
    :max-length="maxLength"
    :append-icon="appendIcon"
    @click:append="$emit('click:append', $event)"
    @keyup.enter="$emit('keyup.enter', $event)"
    @blur="onBlur($event)"
    @change="$emit('change', $event)"
  />
</template>
<script lang="ts">
import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import TextInputMixin from '@/mixins/inputMixins/subMixins/TextInputMixin';
import RulesMixin from '@/mixins/RulesMixin';
import { LocaleMessage } from 'vue-i18n';

@Component
export default class TextInput extends mixins(TextInputMixin, RulesMixin) {
  @Prop(String) readonly id: string | undefined;
  @Prop(String) readonly value: string | undefined;
  @Prop(String) readonly label: string | undefined;
  @Prop(String) readonly appendIcon: string | undefined;
  @Prop(Number) readonly maxLength!: number | string | undefined;
  @Prop({ default: Array }) readonly rules!: ((v: string) => string | boolean | LocaleMessage)[];
  @Prop(Boolean) readonly disabled!: boolean;

  get allRules(): ((v: string) => string | boolean | LocaleMessage)[] {
    return [...this.rules, this.$rule.allowedCharacters];
  }

  onBlur(event: Event): void {
    const trimmed = this.trimInput(this.value);
    if (trimmed !== this.value) {
      this.$emit('input', trimmed);
    }
    this.$emit('blur', event);
  }
}
</script>
